<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="fechar">
    <q-card style="min-width: 360px; max-width: 520px">
      <q-card-section>
        <div class="text-subtitle1">Conectar outra empresa</div>
        <div class="text-body2 q-mt-sm">
          Gere um código e informe-o na outra empresa. Vale por 30 minutos, uma única vez.
        </div>
        <div class="text-caption text-grey-7 q-mt-sm">
          O código some desta tela ao fechar. Passe-o por um canal de confiança.
        </div>
      </q-card-section>

      <q-card-section v-if="!codigo" class="text-center q-pa-lg">
        <q-btn
          label="Gerar código"
          color="primary"
          unelevated
          :loading="carregando"
          :disable="carregando"
          @click="gerar"
        />
      </q-card-section>

      <q-card-section v-else class="text-center">
        <div class="text-h5 text-weight-bold letra-codigo">{{ codigo }}</div>
        <q-chip
          class="q-mt-sm"
          :color="contagemExpirada ? 'red' : 'primary'"
          text-color="white"
          icon="timer"
          :label="contagemExpirada ? 'Código expirado' : `Expira em ${contagemFormatada}`"
        />
        <div class="q-mt-sm">
          <q-btn
            flat
            dense
            icon="content_copy"
            label="Copiar"
            color="primary"
            :disable="contagemExpirada"
            @click="copiar"
          />
          <q-btn
            flat
            dense
            icon="autorenew"
            label="Gerar outro"
            color="grey-8"
            :loading="carregando"
            :disable="carregando"
            @click="gerar"
          />
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Fechar" color="grey-8" @click="fechar" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import contagemRegressiva from "@/mixins/contagem-regressiva";

export default {
  name: "ConexaoCaixaCompartilharDialog",

  emits: ["update:modelValue"],

  mixins: [contagemRegressiva],

  props: {
    modelValue: { type: Boolean, default: false },
  },

  computed: {
    ...mapGetters(["conexaoCaixaConvite", "conexaoCaixaVinculoLoading"]),

    codigo()     { return (this.conexaoCaixaConvite && this.conexaoCaixaConvite.codigo) || null; },
    expiraEm()   { return (this.conexaoCaixaConvite && this.conexaoCaixaConvite.expira_em) || null; },
    carregando() { return this.conexaoCaixaVinculoLoading; },
  },

  watch: {
    expiraEm: {
      immediate: true,
      handler(valor) { this.iniciarContagem(valor); },
    },

    // Ao fechar por qualquer caminho, a credencial sai da memória do Vuex.
    modelValue(aberto) {
      if (!aberto) {
        this.pararContagem();
        this.limparConviteConexaoCaixa();
      }
    },
  },

  beforeUnmount() {
    this.limparConviteConexaoCaixa();
  },

  methods: {
    ...mapActions(["gerarConviteConexaoCaixa", "limparConviteConexaoCaixa"]),

    async gerar() {
      const res = await this.gerarConviteConexaoCaixa();
      if (!res.ok) {
        this.$q.notify({ message: res.erro.mensagem, color: "red", position: "top-right" });
      }
    },

    copiar() {
      if (!this.codigo) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.codigo).then(
          () => this.$q.notify({ message: "Código copiado.", color: "green", position: "top-right" }),
          () => this.avisarCopiaManual()
        );
        return;
      }
      this.avisarCopiaManual();
    },

    avisarCopiaManual() {
      this.$q.notify({
        message: "Não foi possível copiar automaticamente. Anote o código antes de fechar esta janela.",
        color: "orange",
        position: "top-right",
      });
    },

    fechar() {
      this.pararContagem();
      this.limparConviteConexaoCaixa();
      this.$emit("update:modelValue", false);
    },
  },
};
</script>

<style scoped>
.letra-codigo {
  letter-spacing: 0.25em;
  font-family: monospace;
}
</style>
